import { render, staticRenderFns } from "./TiltakListElement.vue?vue&type=template&id=28547010"
import script from "./TiltakListElement.vue?vue&type=script&lang=js"
export * from "./TiltakListElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports